<div class="acct-operation-event container-fluid mb-2 position-relative">
	<div class="row align-items-stretch">
		<div class="col-4 bg-light py-3">
			<h5 class="ps-3 mt-1">Workflow</h5>
			<div class="d-flex flex-column">
				<div class="acct-operation-event__item purple-arrow">
					<strong>Initial Status:</strong>
					{{ initialStatusLabel }}
				</div>
				<div class="acct-operation-event__item purple-arrow">
					<strong>Workflow Action:</strong>
					{{ wfActionLabel }}
				</div>
				<div class="acct-operation-event__item">
					<strong>Resulting Status</strong>
					{{ resultingStatusLabel }}
				</div>
			</div>
		</div>
		<div class="col-8 p-3">
			<div>
				<h5 class="mt-1">Revenue Allocation</h5>
				<div class="row acct-operation-event__accounts-row">
					@if(displayFeeType) {
						<div class="d-flex col-4 flex-column acct-operation-event__item">
							<strong>Fee Type(s)</strong>
							@if (revCreditDebitAccountOrGroups?.length === 0)
						{
								<span class="text-muted">None</span>
							}
							@for (accountOrGroup of revCreditDebitAccountOrGroups; track $index)
						{
								<span>
									<span>{{ accountOrGroup.feeTypeCharVal?.charValueLabel }}</span>
								</span>
							}
						</div>
					}
					<div class="d-flex flex-column acct-operation-event__item"
						[class]="displayFeeType ? 'col-4' : 'col-5'">
						<strong>Debit Account(s)</strong>
						@if (revCreditDebitAccountOrGroups?.length === 0)
						{
							<span class="text-muted">None</span>
						}
						@for (accountOrGroup of revCreditDebitAccountOrGroups; track $index)
						{
							<span>
								@if (accountOrGroup.debitId.isGroup && accountOrGroup.allocationType ===
							AllocationType.Revenue) {
									<div class="d-flex flex-column">
										<span>{{ accountOrGroup.debitName }}</span>
										<em>(Account Group)</em>
									</div>
								} @else {
									<span>{{ accountOrGroup.debitName }}</span>
								}
							</span>
						}
					</div>
					<div class="d-flex flex-column acct-operation-event__item"
						[class]="displayFeeType ? 'col-4' : 'col-5'">
						<strong>Credit Account(s)</strong>
						@if (revCreditDebitAccountOrGroups?.length === 0)
						{
							<span class="text-muted">None</span>
						}
						@for (accountOrGroup of revCreditDebitAccountOrGroups; track $index)
						{
							<span>
								@if (accountOrGroup.creditId.isGroup && accountOrGroup.allocationType ===
							AllocationType.Revenue) {
									<div class="d-flex flex-column">
										<span>{{ accountOrGroup.creditName }}</span>
										<em>(Account Group)</em>
									</div>
								} @else {
									<span>{{ accountOrGroup.creditName }}</span>
								}
							</span>
						}
					</div>
				</div>
			</div>
			@if (hasCostAllocation && hasCostAllocationTemplate) {
				<div class="border-top pt-2 mt-1">
					<h5 class="mt-1">Cost Allocation</h5>
					<div class="row acct-operation-event__accounts-row">
						<div class="d-flex flex-column acct-operation-event__item"
							[class]="displayFeeType ? 'col-4' : 'col-5'">
							<strong>Debit Account(s)</strong>
							@if (costCreditDebitAccountOrGroups?.length === 0)
						{
								<span class="text-muted">None</span>
							}
							@for (accountOrGroup of costCreditDebitAccountOrGroups; track $index)
						{
								<span>
									@if (accountOrGroup.debitId.isGroup && accountOrGroup.allocationType ===
							AllocationType.Cost) {
										<div class="d-flex flex-column">
											<span>{{ accountOrGroup.debitName }}</span>
											<em>(Account Group)</em>
										</div>
									} @else {
										<span>{{ accountOrGroup.debitName }}</span>
									}
								</span>
							}
						</div>
						<div class="d-flex flex-column acct-operation-event__item"
							[class]="displayFeeType ? 'col-4' : 'col-5'">
							<strong>Credit Account(s)</strong>
							@if (costCreditDebitAccountOrGroups?.length === 0)
						{
								<span class="text-muted">None</span>
							}
							@for (accountOrGroup of costCreditDebitAccountOrGroups; track $index)
						{
								<span>
									@if (accountOrGroup.creditId.isGroup && accountOrGroup.allocationType ===
							AllocationType.Cost) {
										<div class="d-flex flex-column">
											<span>{{ accountOrGroup.creditName }}</span>
											<em>(Account Group)</em>
										</div>
									} @else {
										<span>{{ accountOrGroup.creditName }}</span>
									}
								</span>
							}
						</div>
					</div>
				</div>
			}
		</div>
	</div>
	<div class="position-absolute acct-operation-event__accounts-buttons align-items-center justify-content-end pe-2">
		<ng-content></ng-content>
	</div>
</div>